/* global gtag*/

/* eslint-disable arrow-parens */
export class Test {
	constructor(game) {
		this.game = game;
		this.test = document.getElementById('test');
		this.questions = this.test.querySelectorAll('.test__content');
		this.correctAnswers = [2, 1, 3, 0];
		this.btnNext = this.test.querySelector('.test__next');
		this.btnsAnswer = this.test.querySelectorAll('.test__answer-wrapper');
		this.counter = this.test.querySelector('.test__counter');
		this.counterText = this.counter.querySelector('.test__counter-text');
		this.startText = this.test.querySelector('.test__start-text');
		this.finish = this.test.querySelector('.test__finish');
		this.step = 0;
		this.blockAnswers = false;
		this.score = 0;
		this.btnStartTest = document.getElementById('start-test');
		this.btnVision = false;
		this.stepForShowBtn = this.game.maxBlocks / 2;
		this.completed = false;

		this.btnsAnswer.forEach(el => {
			el.addEventListener('click', this.answerHendler.bind(this));
		});

		this.btnNext.addEventListener('click', this.nextStep.bind(this));
		this.btnStartTest.addEventListener('click', this.start.bind(this));
		this.questions[this.step].classList.remove('is-hidden');
	}

	answerHendler(e) {
		if (!this.blockAnswers) {
			const btn = e.currentTarget;

			if (Number(btn.dataset.index) === this.correctAnswers[this.step]) {
				btn.classList.add('answer-correct');
				this.score++;
			} else {
				const correctAnswer = this.questions[this.step].querySelector(`[data-index="${this.correctAnswers[this.step]}"]`);
				correctAnswer.classList.add('answer-correct');
				btn.classList.add('answer-error');
			}

			if (this.step === this.questions.length - 1) {
				this.btnNext.querySelector('.button__text').textContent = 'завершить';
			}

			// analytics
			gtag('event', 'question_answer', {
				event_category: e.currentTarget.textContent.trim(),
				event_label: this.step + 1,
			});

			this.btnNext.classList.remove('is-hidden');
			this.blockAnswers = true;
		}
	}

	nextStep() {
		if (this.questions[this.step]) {
			this.questions[this.step].classList.add('is-hidden');
			this.step++;

			// analytics
			if (this.step < this.questions.length) {
				gtag('event', 'question_show', {
					event_label: this.step + 1,
				});
			}
		} else {
			this.game.popupMain.handler();
			this.game.play();
			this.game.updateScore(20);
			this.test.classList.add('is-hidden');
			this.completed = true;
		}

		if (this.step < this.questions.length) {
			this.startText.classList.add('is-hidden');
			this.btnNext.classList.add('is-hidden');
			this.questions[this.step].classList.remove('is-hidden');
			this.blockAnswers = false;
			this.counterText.textContent = `${this.step + 1}/${this.questions.length}`;
		} else if (this.step === this.questions.length) {
			this.finish.classList.remove('is-hidden');
			this.counter.classList.add('is-hidden');
			this.btnNext.querySelector('.button__text').textContent = 'продолжить игру';

			// analytics
			gtag('event', 'test_finish', {
				event_label: this.score,
			});
		}
	}

	start() {
		this.game.popupMain.handler();
		this.game.popupMain.popup.classList.add('popup--test');
		this.test.classList.remove('is-hidden');
		this.game.sound.backgroundSound.pause();

		// analytics
		gtag('event', 'test_start');
		gtag('event', 'question_show', {
			event_label: this.step + 1,
		});
	}

	close() {
		this.game.popupMain.popup.classList.remove('popup--test');
		this.test.classList.add('is-hidden');

		if (this.completed) {
			this.btnStartTest.classList.remove('is-vision');
		}
	}

	showBtn() {
		if (this.game.currentBlocks > this.stepForShowBtn && !this.btnVision) {
			this.btnStartTest.classList.add('is-vision');
			this.btnVision = true;
		}
	}

	reset() {
		this.btnStartTest.classList.remove('is-vision');
		this.completed = false;
		this.blockAnswers = false;
		this.step = 0;
		this.score = 0;
		this.btnVision = false;
		this.finish.classList.add('is-hidden');
		this.questions[this.step].classList.remove('is-hidden');
		this.counter.classList.remove('is-hidden');
		this.counterText.textContent = `${this.step + 1}/${this.questions.length}`;
		this.btnNext.classList.add('is-hidden');
		this.startText.classList.remove('is-hidden');
		this.btnsAnswer.forEach(btn => {
			btn.classList.remove('answer-error');
			btn.classList.remove('answer-correct');
		});
		this.btnNext.querySelector('.button__text').textContent = 'продолжить';
	}
}
